var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.67578 6.03285C1.67578 5.66968 1.87267 5.33506 2.19014 5.15869L9.19014 1.2698C9.49216 1.10201 9.8594 1.10201 10.1614 1.2698L17.1614 5.15869C17.4789 5.33506 17.6758 5.66968 17.6758 6.03285V10.6715C17.6758 14.3032 15.7069 17.6494 12.5322 19.4131L10.1614 20.7302C9.8594 20.898 9.49216 20.898 9.19014 20.7302L6.81935 19.4131C3.6447 17.6494 1.67578 14.3032 1.67578 10.6715L1.67578 6.03285Z",
    stroke: "#0D4740",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicy);
export default __webpack_public_path__ + "static/media/policy.964ecde01af89ceec9bd8a486f47060e.svg";
export { ForwardRef as ReactComponent };